import { Component, ViewChild, ElementRef, HostListener, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../../../services/layout.service';

import { Subscription } from 'rxjs';
import { BaseService } from '../../../';
import { I18Service } from '../../../services/i18Service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CryptoService } from '../../../services/crypto.service';
import { roles } from '../../../consts/roles';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    filter: any = {
        Id: ""
    };
    private subscriptions: Subscription[] = [];
        lang;

    model: any[] = [];
    sideMenu: any;
    userInfo = JSON.parse(localStorage.getItem('userInfo'))


    @ViewChild("insideElement") insideElement;
    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement) {
        const clickedInside = this.insideElement.nativeElement.contains(targetElement);
        if (!clickedInside) {
            if (!this.layoutService.openSideMenu) {
                if (this.lang == 'ar') {
                    if (!this.layoutService.state.staticMenuMobileActive && !this.layoutService.isDesktop()) {
                        this.layoutService.onMenuToggle()
                        if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
                             ;
                            // this.layoutService.onMenuToggle()

                        }

                    }
                } else {
                    if (this.layoutService.state.staticMenuMobileActive && !this.layoutService.isDesktop()) {
                        this.layoutService.onMenuToggle()
                        if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
                             ;
                            // this.layoutService.onMenuToggle()

                        }

                    }
                }

            } else {
                this.layoutService.openSideMenu = false;
            }



        }
    }

    constructor(private deviceService: DeviceDetectorService, public auth: AuthService,
        public layoutService: LayoutService, public el: ElementRef,
        private baseService: BaseService, private crypto: CryptoService,
        private translate: TranslateService, public router: Router,
        private i18Service: I18Service) {

        this.translate.setDefaultLang(localStorage.getItem('lang') || 'ar');
        this.translate.use(localStorage.getItem('lang') || 'ar');
        this.lang = localStorage.getItem('lang') || 'ar';
        if (this.lang == 'ar') {
            if (!this.layoutService.state.staticMenuMobileActive && !this.layoutService.isDesktop()) {
                this.layoutService.onMenuToggle()

                if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
                     ;

                }
            }
        } else {
            if (this.layoutService.state.staticMenuMobileActive && !this.layoutService.isDesktop()) {
                this.layoutService.onMenuToggle()

                if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
                     ;

                }
            }
        }


    }

    ngOnInit() {
        
        // if (localStorage.getItem("sideMenu")) {
        //     sideMenuList = JSON.parse(localStorage.getItem("sideMenu"))
        // }

        this.i18Service.getLocalEvent()
            .subscribe(local => this.translate.use(local))

        let sideMenuList = [];
        this.model = [

            {
                label: '',
                items: sideMenuList
            },

        ];

        this.getSideMenu();

    }
    setNewUrl(oldList) {
        oldList.forEach(element => {
            element.icon = 'pi pi-align-justify';
            if (element.url) {
                element.url = element.url.replace('/admin/main.html#', '');

            }
            if (element.subMenu.length > 0) {
                element.subMenu.forEach(elementSub => {
                    elementSub.url = elementSub.url.replace('/admin/main.html#', '');

                });
                element.items = element.subMenu;

            }

        });
         ;
        return oldList;
    }

    getSideMenu() {

        
        this.filter.id = JSON.parse(localStorage.getItem('userInfo')).id;

        let subscription = this.baseService.post('menus/GetAdminMenu', this.filter)
            .subscribe({
                next: (res: any) => {
                    this.sideMenu = res.output.MenusEntity;
                    this.model[0].items = this.setNewUrl(this.sideMenu);


                    localStorage.setItem("sideMenu", JSON.stringify(this.model[0].items));

                     ;
                }
                , error: (error: string) => {
                     ;
                }
            });
        this.subscriptions.push(subscription);
     
    }

    closeMenu() {
        if (!this.layoutService.isDesktop()) {
            this.layoutService.onMenuToggle()
        }
    }


}
